export default __webpack_public_path__ + "media/images/triangle_pdg-1db8173cf63566c70b3e2ec6830a154a.png";